module.exports = __webpack_public_path__ + "date-caret.svg?32da696261be5c1157396f5c32d0f9ab";